import fetch, { fetchJson } from 'utils/fetch';

export const getByCustomer = customer =>
  fetchJson(`/pco-manager/customers/${customer}/sites.json`);

export const displayCreate = customer =>
  fetch(`/pco-manager/customers/${customer}/sites/new.json`).then(res =>
    res.text()
  );

export const create = (customer, data) =>
  fetch(`/pco-manager/customers/${customer}/sites/new.json`, {
    method: 'POST',
    body: data,
  }).then(res => res.json());



// WEBPACK FOOTER //
// ./src/modules/saas/sites/api/index.js